import React, {FC, memo, useMemo, useState} from 'react'
import {Headers, Sort, SortKeys, SortOrder} from '../types'
import {PeriodType} from '../../../../../global'
import {SearchedData} from '../../../../../app/features'
import {paginate} from '../../../content/pagination/types'
import {THead} from '../components/THead'
import {Pagination} from '../../../content/pagination/Pagination'
import {ConversionClicksNumberClicks} from '../../../../../app/@types'
import {Row} from './Row'

interface TablesWidget27Interface {
    data: ConversionClicksNumberClicks[]
    period: PeriodType
    searchQuery: string
}

const headers: Headers<ConversionClicksNumberClicks>[] = [
    {key: 'dateHour', label: 'Date', className: 'fw-bolder text-muted bg-light min-w-150px'},
    {key: 'eventCount', label: 'Clics', className: 'fw-bolder text-muted bg-light  min-w-25px'},
    {key: 'sessionSource', label: 'Source', className: 'fw-bolder text-muted bg-light min-w-250px'},
    {key: 'pagePath', label: 'Chemin', className: 'fw-bolder text-muted bg-light min-w-200px'},
    {key: 'city', label: 'Ville', className: 'fw-bolder text-muted bg-light min-w-200px'},
    {key: 'browser', label: 'Navigateur', className: 'fw-bolder text-muted bg-light min-w-150px'},
    {key: 'platformDeviceCategory', label: 'appareil', className: 'fw-bolder text-muted bg-light min-w-150px'},
]

const TablesWidget27: FC<TablesWidget27Interface> = memo(({data, period, searchQuery}) => {

    const [sortKey, setSortKey] = useState<SortKeys<ConversionClicksNumberClicks>>('dateHour')
    const [sortOrder, setSortOrder] = useState<SortOrder>('desc')
    const [currentPage, setCurrentPage] = useState(1)
    const [itemsPerPage, setItemsPerPage] = useState(10)

    const dataSorted: ConversionClicksNumberClicks[] = useMemo(() => {
        return Sort<ConversionClicksNumberClicks>({data, sortKey, reverse: sortOrder === 'desc'})
    }, [data, sortKey, sortOrder])

    const filteredData = useMemo(() => {
        return SearchedData<ConversionClicksNumberClicks>(dataSorted, searchQuery)
    }, [dataSorted, searchQuery])

    const paginateData = useMemo(
        () => paginate<ConversionClicksNumberClicks>({currentPage, itemsPerPage, data: filteredData}),
        [currentPage, itemsPerPage, filteredData],
    )

    return (
        <>
            <div className="table-responsive">
                <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">
                    <THead headers={headers}
                           sortKey={sortKey}
                           setSortKey={setSortKey}
                           sortOrder={sortOrder}
                           setSortOrder={setSortOrder}
                           children={<th />}
                    />
                    <tbody>
                        <Row data={paginateData} />
                    </tbody>
                </table>
            </div>
            <Pagination itemsPerPage={itemsPerPage}
                        totalItems={data.length}
                        setCurrentPage={setCurrentPage}
                        setItemsPerPage={setItemsPerPage}
            />
        </>
    )
})

export {TablesWidget27}